<template>
  <v-container fluid><ScaleSwapsList /> </v-container>
</template>

<script>
import ScaleSwapsList from './components/ScaleSwapsList'
export default {
  name: 'ScaleSwaps',
  components: { ScaleSwapsList },
  data: () => {
    return {}
  },
}
</script>
